export const VALIDATE_OTP_START = 'VALIDATE_OTP_START';
export const VALIDATE_OTP_SUCCESS = 'VALIDATE_OTP_SUCCESS';
export const VALIDATE_OTP_FAIL = 'VALIDATE_OTP_FAIL';
export const VALIDATE_OTP_RESET = 'VALIDATE_OTP_RESET';
